import React, { useState, useEffect } from "react";
import FormInput from "../FormInput/FormInput";
import { registerData } from "../../data";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { EmptyingAllInputs, Notification } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import {
  sendOtpEmailRegister,
  clearErrors,
} from "../../redux/actions/userActions";
import Loader from "../Loader/Loader";

const Register = ({ getData }) => {
  const { error, loading, response, success } = useSelector(
    (state) => state.user
  );
  const dispatch = useDispatch();
  const initialState = {};
  registerData.map((item) => (initialState[item.name] = ""));

  const [form, setForm] = useState(initialState);
  const [email, setEmail] = useState("");

  const registerSchema = yup.object().shape({
    fullName: yup.string().required("Full name is required"),
    age: yup
      .number()
      .typeError("Age must be an integer")
      .required("Age is required")
      .positive("Age must be positive")
      .integer("Age must be an integer")
      .min(12, "Age must be greater than 12"),
    gender: yup.string().required("Gender is required"),
    education: yup.string().required("Education name is required"),
    employmentStatus: yup.string().required("Employment Status is required"),
    locationProvince: yup.string().required("Province is required"),
    phoneNumber: yup.string().required("Phone Number is required"),
    email: yup
      .string()
      .email("Field should contain a valid e-mail")
      .max(255)
      .required("E-mail is required"),

    password: yup
      .string()
      .required("Password Required")
      .min(8, "Passowrd must be 8 character long")
      .matches(/[A-Z]/, "Password must contain one uppercase")
      .matches(/([a-z])/, "Password must contain one lowercase")
      .matches(/(\d)/, "Password must contain one number")
      .matches(/(\W)/, "Password must contain one special character"),

    confirmPassword: yup
      .string()
      .required("Confirm Password Required")
      .oneOf([yup.ref("password"), null], "Passwords must match"),
  });

  const {
    register,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(registerSchema),
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
    setValue(name, value, { shouldValidate: true });
  };

  const onSubmit = (data) => {
    dispatch(sendOtpEmailRegister(data));
    setEmail(data.email);
    reset();
    EmptyingAllInputs();
  };

  useEffect(() => {
   
      Notification(success, error, response);
    

    dispatch(clearErrors());
    if (success && response !== undefined) {
      getData(success, email);
    }
  }, [dispatch, error, loading, response, success, email, getData]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          {registerData.map((item, index) => {
            return (
              <div className="col-12" key={index}>
                <FormInput
                  tag={item.tag}
                  type={item.type}
                  name={item.name}
                  placeholder={item.placeholder}
                  options={item.options}
                  onChange={handleChange}
                  error={errors[item.name]}
                  register={register}
                  defaultValue={""}
                />
              </div>
            );
          })}

          <div className="col-12">
            <div className="contact-btn">
              <button type="submit">
                {loading ? <Loader /> : "Submit"}
                <span className="ti-arrow-right" />
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default Register;
